import React from 'react';

const ContentHeader = ({ id, title, description, children }) => (
	<section className="content-header">
		{children}
		<h1 id={id}>
			{title}
			<small dangerouslySetInnerHTML={{ __html: description }}></small>
		</h1>
	</section>
)

export default ContentHeader;




// WEBPACK FOOTER //
// ./src/areas/shared/components/contentHeader/ContentHeader.js